export const ROLES = {
    ADMIN: "ADMIN",
    STORE_MANAGER: "STORE_MANAGER",
}